export default __webpack_public_path__ + "static/0298-c2ffb3e96c0b147507bbf868ee9d8900.png";